module.exports = __webpack_public_path__ + "img/circle-b.67022dbf.svg";